import { Injectable } from '@angular/core';
import { FormControl,FormGroup,Validators } from '@angular/forms';
import {
AccountsReceivableLedgerEntity,
AccountsReceivableLedgerTypeEnum
} from '../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { FormControlCache } from './formcontrol-cache';
import * as mjsHelper from '../../../helper/math-js-helper';
import { arlTableDataArlForm } from './arl-form-data.service';
import { Require } from '../../../helper/helper';


export type calculationArlFormGroup = FormGroup<calculationArlForm>;
export type calculationArlForm = {
    // costAmountWithoutTax: FormControl<number>;
    ItemNumber: FormControl<string>;
    BaseCost: FormControl<number>;
    BaseCostGross: FormControl<number>;
    CostAmount: FormControl<number>;
    Quantity: FormControl<number>;
    QuantityTypeId: FormControl<number>;
    Information: FormControl<string>;
    BookingText: FormControl<string>;
    Type: FormControl<AccountsReceivableLedgerTypeEnum>;
    ResourceId: FormControl<number>;
    MaterialId: FormControl<number>;
    JobSpecificationId: FormControl<number>;
    IsVisible: FormControl<boolean>;
    IsOptional: FormControl<boolean>;
    CrossedOut: FormControl<boolean>;
    Id: FormControl<number>;
    IndividuallyCostCalculation: FormControl<boolean>;
    HideInGroupSummary: FormControl<boolean>;
    SupplierId: FormControl<number>;
    CostAmountAllowance: FormControl<number>;
    ParentId: FormControl<number>;
    QuantityFormula: FormControl<string>;
    QuantityFormulaUsedVariables: FormControl<string[]>;
    SurchargeOverride: FormControl<number | null>;
};
@Injectable()
export class CalculationArlFormDataService extends FormControlCache<calculationArlFormGroup> {
    getFormByEntity(arl: AccountsReceivableLedgerEntity | null, childrenVisible: boolean) {
        let form: calculationArlFormGroup = arl && this.getForm(arl.Id);
        if (!form) {
            form = this.createFormGroup({
                ItemNumber: arl ? arl.ItemNumber : AccountsReceivableLedgerEntity.autogenerateItemNumber,
                BaseCost: arl ? arl.BaseCost : null,
                BaseCostGross: arl ? arl.BaseCostGross : null,
                CostAmount: arl ? arl.CostAmount : null,
                Quantity: arl ? arl.Quantity : null,
                QuantityTypeId: arl ? arl.QuantityTypeId : null,
                Information: arl ? arl.Information : null,
                BookingText: arl ? arl.BookingText : null,
                Type: arl ? arl.Type : AccountsReceivableLedgerTypeEnum.Arl,
                ResourceId: arl ? arl.ResourceId : null,
                MaterialId: arl ? arl.MaterialId : null,
                JobSpecificationId: arl ? arl.JobSpecificationId : null,
                IsVisible: arl ? arl.IsVisible : childrenVisible,
                IsOptional: arl ? arl.IsOptional : false,
                CrossedOut: arl ? arl.CrossedOut : false,
                Id: arl ? arl.Id : null,
                HideInGroupSummary: arl ? arl.HideInGroupSummary : false,
                IndividuallyCostCalculation: arl ? arl.IndividuallyCostCalculation : false,
                SupplierId: arl ? arl.SupplierId : null,
                CostAmountAllowance: arl ? arl.CostAmountAllowance : null,
                ParentId: arl ? arl.ParentId : null,
                QuantityFormula: arl ? arl.QuantityFormula : null,
                QuantityFormulaUsedVariables: arl ? (arl.QuantityFormula ? mjsHelper.getUsedVariableNames(arl.QuantityFormula) : []) : [],
                SurchargeOverride: arl ? arl.SurchargeOverride : null,
            });
            if (arl?.Id) {
                this.setForm(arl.Id, form);
            }
        }
        // console.log(form);
        return form;
    }
    setFormByArlForm(arlForm: arlTableDataArlForm, missingValues: Pick<Required<calculationArlFormGroup['value']>, 'IsVisible' | 'IndividuallyCostCalculation' | 'CostAmountAllowance'>, overrideValues: Partial<calculationArlFormGroup['value']> = {}) {
        if (arlForm.controls.childArls.length) {
            throw new Error('Cannot set form for ARL with child ARLs');
        }
        if (this.getForm(arlForm.controls.Id.getRawValue())) {
            throw new Error('Form already exists');
        }
        const form = this.createFormGroup({
            ItemNumber: arlForm.controls.ItemNumber.getRawValue(),
            BaseCost: arlForm.controls.BaseCost.getRawValue(),
            BaseCostGross: arlForm.controls.BaseCostGross.getRawValue(),
            CostAmount: arlForm.controls.CostAmount.getRawValue(),
            Quantity: arlForm.controls.Quantity.getRawValue(),
            QuantityTypeId: arlForm.controls.QuantityTypeId.getRawValue(),
            Information: arlForm.controls.Information.getRawValue(),
            BookingText: arlForm.controls.BookingText.getRawValue(),
            Type: arlForm.controls.Type.getRawValue(),
            ResourceId: arlForm.controls.ResourceId.getRawValue(),
            MaterialId: arlForm.controls.MaterialId.getRawValue(),
            JobSpecificationId: arlForm.controls.JobSpecificationId.getRawValue(),
            IsOptional: arlForm.controls.IsOptional.getRawValue(),
            CrossedOut: arlForm.controls.CrossedOut.getRawValue(),
            Id: arlForm.controls.Id.getRawValue(),
            HideInGroupSummary: arlForm.controls.HideInGroupSummary.getRawValue(),
            SupplierId: arlForm.controls.SupplierId.getRawValue(),
            ParentId: arlForm.controls.ParentId.getRawValue(),
            QuantityFormula: arlForm.controls.QuantityFormula.getRawValue(),
            QuantityFormulaUsedVariables: arlForm.controls.QuantityFormulaUsedVariables.getRawValue(),
            SurchargeOverride: arlForm.controls.SurchargeOverride.getRawValue(),

            IsVisible: missingValues.IsVisible,
            IndividuallyCostCalculation: missingValues.IndividuallyCostCalculation,
            CostAmountAllowance: missingValues.CostAmountAllowance,

            ...overrideValues,
        });
        this.setForm(arlForm.controls.Id.getRawValue(), form);

        // console.log(form);
        return form;
    }
    private createFormGroup(initialValue: calculationArlFormGroup['value']): calculationArlFormGroup {
        return new FormGroup({
            ItemNumber: new FormControl<string>(initialValue.ItemNumber, { nonNullable: false }),
            BaseCost: new FormControl<number>(initialValue.BaseCost, { nonNullable: true }),
            BaseCostGross: new FormControl<number>(initialValue.BaseCostGross, { nonNullable: true }),
            CostAmount: new FormControl<number>(initialValue.CostAmount, { nonNullable: true }),
            Quantity: new FormControl<number>(initialValue.Quantity, { nonNullable: true }),
            QuantityTypeId: new FormControl<number>(initialValue.QuantityTypeId, { nonNullable: true }),
            Information: new FormControl<string>(initialValue.Information, { nonNullable: true }),
            BookingText: new FormControl<string>(initialValue.BookingText, { nonNullable: true }),
            Type: new FormControl<AccountsReceivableLedgerTypeEnum>(initialValue.Type, { nonNullable: true, validators: Validators.required }),
            ResourceId: new FormControl<number>(initialValue.ResourceId, { nonNullable: true }),
            MaterialId: new FormControl<number>(initialValue.MaterialId, { nonNullable: true }),
            JobSpecificationId: new FormControl<number>(initialValue.JobSpecificationId, { nonNullable: true }),
            IsVisible: new FormControl<boolean>(initialValue.IsVisible, { nonNullable: true }),
            IsOptional: new FormControl<boolean>(initialValue.IsOptional, { nonNullable: true }),
            CrossedOut: new FormControl<boolean>(initialValue.CrossedOut, { nonNullable: true }),
            Id: new FormControl<number>(initialValue.Id, { nonNullable: true }),
            HideInGroupSummary: new FormControl<boolean>(initialValue.HideInGroupSummary, { nonNullable: false }),
            IndividuallyCostCalculation: new FormControl<boolean>(initialValue.IndividuallyCostCalculation, { nonNullable: true }),
            SupplierId: new FormControl<number>(initialValue.SupplierId, { nonNullable: true }),
            CostAmountAllowance: new FormControl<number>(initialValue.CostAmountAllowance, { nonNullable: true }),
            ParentId: new FormControl<number>(initialValue.ParentId, { nonNullable: true }),
            QuantityFormula: new FormControl<string>(initialValue.QuantityFormula, { nonNullable: true }),
            QuantityFormulaUsedVariables: new FormControl<string[]>(initialValue.QuantityFormulaUsedVariables, { nonNullable: true }),
            SurchargeOverride: new FormControl<number>(initialValue.SurchargeOverride, { nonNullable: true }),
        })
    }
}
